import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
// import config from './config/config.js'

// 引入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'

// 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 注册为全局组件
Vue.use(VueQuillEditor)

Vue.use(ElementUI);
Vue.config.productionTip = false

// 将 axios 挂载到 Vue 原型上
Vue.prototype.$http = axios;
// 将 config 挂载到 Vue 原型上
// Vue.prototype.$config = config;
Vue.prototype.$config = window.AppConfig || {};

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    config.headers['Authorization'] = localStorage.getItem('token') || '';
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应处理
axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry && error.response.data.msg == 'errorAuthorization') {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem('refreshToken') || "Null";
        const res = await axios.post(config.serviceUrl + '/sys/refreshToken', refreshToken);
        if (res.data.success) {
          const token = res.data.token;
          localStorage.setItem('token', token);
          originalRequest.headers.Authorization = `${token}`;
          return axios(originalRequest);
        } else {
          // Refresh Token 也过期，跳转登录页
          window.top.location.href = '/';
          return Promise.reject();
        }
      } catch (refreshError) {
        // Refresh Token 也过期，跳转登录页
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
